/* Componi il tuo substrato — logica del builder (sections/tc-mix.liquid).
   Stessa logica della vecchia pagina incollata nel corpo Shopify:
   - volumi = varianti del prodotto "substrato-personalizzato"
   - ingredienti = prodotti con il tag "componi" (da /products.json, paginato a 250)
   - minimo 2 inerti per procedere
   - al carrello: variante + proprietà Composizione e Nome (POST /cart/add) */
(function () {
  "use strict";

  var wrapper = document.querySelector("[data-tc-mix]");
  if (!wrapper) return;

  var isEn = wrapper.dataset.lang === "en";
  var t = {};
  try {
    t = JSON.parse(wrapper.querySelector("[data-tc-mix-i18n]").textContent);
  } catch (e) {}

  var productHandle = "substrato-personalizzato";
  var targetTag = "componi";

  var form = document.getElementById("substrato-builder-form");
  var steps = wrapper.querySelectorAll(".sb-step");
  var nextButtons = wrapper.querySelectorAll(".sb-next");
  var prevButtons = wrapper.querySelectorAll(".sb-prev");

  var volumeOptionsContainer = document.getElementById("sb-volume-options");
  var ingredientsGrid = document.getElementById("sb-ingredients-grid");

  var hiddenVariantId = document.getElementById("sb-variant-id");
  var composizioneInput = document.getElementById("sb-composizione");
  var customNameHidden = document.getElementById("sb-custom-name-hidden");
  var customNameInput = document.getElementById("sb-custom-name-input");

  var summaryVolume = document.getElementById("sb-summary-volume");
  var summaryPrice = document.getElementById("sb-summary-price");
  var summaryIngredients = document.getElementById("sb-summary-ingredients");

  var progress = document.getElementById("sb-progress");
  var progressSteps = wrapper.querySelectorAll(".sb-progress-step");
  var progressFill = wrapper.querySelector(".sb-progress-fill");

  var volumeRadios = [];
  var ingredientCheckboxes = [];

  function formatPrice(val) {
    var num = parseFloat(val);
    if (isEn) return "€" + num.toFixed(2);
    return "€" + num.toFixed(2).replace(".", ",");
  }

  function message(text) {
    var p = document.createElement("p");
    p.className = "tc-mix__msg";
    p.textContent = text;
    return p;
  }

  /* Scheda informativa (i): montata dentro la sezione, così il CSS isolato la raggiunge */
  function createModal() {
    var modal = document.createElement("div");
    modal.className = "sb-modal-overlay";
    modal.innerHTML =
      '<div class="sb-modal-content">' +
      '<button class="sb-modal-close" type="button" aria-label="×">&times;</button>' +
      '<h3 class="sb-modal-title"></h3>' +
      '<div class="sb-modal-description"></div>' +
      "</div>";
    wrapper.appendChild(modal);

    modal.querySelector(".sb-modal-close").addEventListener("click", function () {
      modal.classList.remove("sb-modal-open");
    });
    modal.addEventListener("click", function (e) {
      if (e.target === modal) modal.classList.remove("sb-modal-open");
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") modal.classList.remove("sb-modal-open");
    });
    return modal;
  }

  var modal = createModal();

  function showModal(title, description) {
    modal.querySelector(".sb-modal-title").textContent = title;
    modal.querySelector(".sb-modal-description").textContent = description;
    modal.classList.add("sb-modal-open");
  }

  function updateProgress(stepIndex) {
    if (!progress) return;

    if (stepIndex === 0) {
      progress.classList.add("sb-progress-hidden");
      progressSteps.forEach(function (ps) {
        ps.classList.remove("sb-progress-active", "sb-progress-completed");
      });
      if (progressFill) progressFill.style.width = "0%";
      return;
    }

    progress.classList.remove("sb-progress-hidden");

    var percentage = ((stepIndex - 1) / (progressSteps.length - 1)) * 100;
    if (progressFill) progressFill.style.width = percentage + "%";

    progressSteps.forEach(function (ps) {
      var s = parseInt(ps.getAttribute("data-step"), 10);
      ps.classList.remove("sb-progress-active", "sb-progress-completed");
      if (s < stepIndex) ps.classList.add("sb-progress-completed");
      else if (s === stepIndex) ps.classList.add("sb-progress-active");
    });
  }

  function syncCustomName() {
    if (customNameHidden && customNameInput) {
      customNameHidden.value = customNameInput.value.trim();
    }
  }

  function showStep(index) {
    steps.forEach(function (step, i) {
      step.classList.toggle("sb-step-active", i === index);
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
    updateProgress(index);
    updateSummary();
  }

  function getSelectedVolumeRadio() {
    for (var i = 0; i < volumeRadios.length; i++) {
      if (volumeRadios[i].checked) return volumeRadios[i];
    }
    return null;
  }

  function updateSummary() {
    var selectedVolume = getSelectedVolumeRadio();
    if (selectedVolume) {
      var title = selectedVolume.getAttribute("data-title") || "";
      var price = selectedVolume.getAttribute("data-price") || "";

      summaryVolume.textContent = title || "–";
      summaryPrice.textContent = price || "–";

      hiddenVariantId.value = selectedVolume.value;
    }

    var ingredients = [];
    ingredientCheckboxes.forEach(function (chk) {
      if (chk.checked) ingredients.push(chk.getAttribute("data-title"));
    });

    if (ingredients.length === 0) {
      summaryIngredients.textContent = t.none;
      composizioneInput.value = t.noneSelected;
    } else {
      var text = ingredients.join(", ");
      summaryIngredients.textContent = text;
      composizioneInput.value = t.ingredientsLabel + text;
    }

    // sincronizza il nome personalizzato nell'hidden
    syncCustomName();
  }

  if (customNameInput) {
    customNameInput.addEventListener("input", syncCustomName);
  }

  nextButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var currentStep = btn.closest(".sb-step");
      var currentIndex = Array.prototype.indexOf.call(steps, currentStep);

      // controllo minimo 2 inerti allo step 2 (index 2)
      if (currentIndex === 2) {
        var selectedCount = 0;
        ingredientCheckboxes.forEach(function (chk) {
          if (chk.checked) selectedCount++;
        });
        if (selectedCount < 2) {
          alert(t.alertMin2);
          return;
        }
      }

      var nextIndex = currentIndex + 1;
      if (nextIndex < steps.length) showStep(nextIndex);
    });
  });

  prevButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var currentStep = btn.closest(".sb-step");
      var currentIndex = Array.prototype.indexOf.call(steps, currentStep);
      var prevIndex = currentIndex - 1;
      if (prevIndex >= 0) showStep(prevIndex);
    });
  });

  form.addEventListener("submit", function () {
    updateSummary();
  });

  function loadProduct() {
    return fetch("/products/" + encodeURIComponent(productHandle) + ".js", { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error(t.errorLoadProd);
        return response.json();
      })
      .then(function (product) {
        volumeOptionsContainer.innerHTML = "";
        volumeRadios = [];

        product.variants.forEach(function (variant, index) {
          var label = document.createElement("label");
          label.className = "sb-volume-option";

          var input = document.createElement("input");
          input.type = "radio";
          input.name = "sb-volume";
          input.value = variant.id;
          input.setAttribute("data-title", variant.title);
          input.setAttribute("data-price", formatPrice(variant.price / 100));
          if (index === 0) input.checked = true;

          var textWrapper = document.createElement("div");

          var main = document.createElement("span");
          main.className = "sb-volume-label-main";
          main.textContent = variant.title;

          var sub = document.createElement("span");
          sub.className = "sb-volume-label-sub";
          sub.textContent = formatPrice(variant.price / 100);

          textWrapper.appendChild(main);
          textWrapper.appendChild(sub);

          label.appendChild(input);
          label.appendChild(textWrapper);
          volumeOptionsContainer.appendChild(label);

          volumeRadios.push(input);
          input.addEventListener("change", updateSummary);
        });

        if (volumeRadios.length > 0) hiddenVariantId.value = volumeRadios[0].value;

        updateSummary();
      })
      .catch(function (error) {
        console.error(error);
        volumeOptionsContainer.innerHTML = "";
        volumeOptionsContainer.appendChild(message(t.errorLoadVol));
      });
  }

  function fetchAllProducts(page, allProducts) {
    page = page || 1;
    allProducts = allProducts || [];

    var limit = 250;
    var url = "/products.json?limit=" + limit + "&page=" + page;

    return fetch(url, { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("Impossibile caricare i prodotti");
        return response.json();
      })
      .then(function (data) {
        var products = Array.isArray(data) ? data : data.products || [];
        allProducts = allProducts.concat(products);

        if (products.length === limit) return fetchAllProducts(page + 1, allProducts);
        return filterProductsByTag(allProducts, targetTag);
      });
  }

  function filterProductsByTag(products, tag) {
    return products.filter(function (prod) {
      if (!prod.tags) return false;
      var tags = Array.isArray(prod.tags)
        ? prod.tags
        : prod.tags.split(",").map(function (x) { return x.trim().toLowerCase(); });
      return tags.includes(tag.toLowerCase());
    });
  }

  function toggleCard(label, input) {
    label.classList.toggle("sb-ingredient-selected", input.checked);
    updateSummary();
  }

  function loadCollection() {
    return fetchAllProducts()
      .then(function (products) {
        ingredientsGrid.innerHTML = "";
        ingredientCheckboxes = [];

        if (!products.length) {
          ingredientsGrid.appendChild(message(t.errorLoadIngr));
          return;
        }

        products.forEach(function (prod) {
          var label = document.createElement("label");
          label.className = "sb-ingredient-card";
          label.tabIndex = 0;

          var input = document.createElement("input");
          input.type = "checkbox";
          input.className = "sb-ingredient-checkbox";
          input.style.display = "none";
          input.setAttribute("data-title", prod.title);

          var imgWrapper = document.createElement("div");
          imgWrapper.className = "sb-ingredient-image-wrapper";

          if (prod.images && prod.images.length > 0) {
            var img = document.createElement("img");
            img.src = prod.images[0].src;
            img.alt = prod.title;
            img.loading = "lazy";
            img.decoding = "async";
            imgWrapper.appendChild(img);
          }

          var info = document.createElement("div");
          info.className = "sb-ingredient-info";

          var title = document.createElement("div");
          title.className = "sb-ingredient-title";
          title.textContent = prod.title;

          var descText = "";
          if (prod.body_html) {
            var tmpDiv = document.createElement("div");
            tmpDiv.innerHTML = prod.body_html;
            descText = (tmpDiv.textContent || tmpDiv.innerText || "").trim();
          }

          info.appendChild(title);

          if (descText) {
            var desc = document.createElement("div");
            desc.className = "sb-ingredient-desc-short";
            var truncated = descText.slice(0, 60);
            desc.textContent = truncated + (descText.length > 60 ? "…" : "");
            info.appendChild(desc);

            if (descText.length > 60) {
              var infoBtn = document.createElement("button");
              infoBtn.type = "button";
              infoBtn.className = "sb-ingredient-info-button";
              infoBtn.textContent = "i";
              infoBtn.setAttribute("aria-label", prod.title);
              infoBtn.addEventListener("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                showModal(prod.title, descText);
              });
              label.appendChild(infoBtn);
            }
          }

          label.appendChild(input);
          label.appendChild(imgWrapper);
          label.appendChild(info);

          ingredientsGrid.appendChild(label);
          ingredientCheckboxes.push(input);

          label.addEventListener("click", function (e) {
            if (e.target.classList.contains("sb-ingredient-info-button") || e.target.closest(".sb-ingredient-info-button")) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            e.preventDefault();
            input.checked = !input.checked;
            toggleCard(label, input);
          });

          // tastiera: le schede si selezionano con Invio/Spazio
          label.addEventListener("keydown", function (e) {
            if ((e.key === "Enter" || e.key === " ") && e.target === label) {
              e.preventDefault();
              input.checked = !input.checked;
              toggleCard(label, input);
            }
          });

          input.addEventListener("change", function () {
            toggleCard(label, input);
          });
        });

        updateSummary();
      })
      .catch(function (error) {
        console.error(error);
        ingredientsGrid.innerHTML = "";
        ingredientsGrid.appendChild(message(t.errorGenericIngr));
      });
  }

  showStep(0);
  loadProduct();
  loadCollection();
})();
